// Whether the promo code box shows on the "Your information" checkout step.
// The payment step always shows it when the template has the field on.
// In 'final_step' mode the information step shows it only when that step
// completes the booking: nothing to pay, or pay on arrival is required, so
// the payment step is skipped.
export function showPromoFieldOnInfoStep({ showField, position, total, payOnArrivalRequired }) {
  if (Number(showField) !== 1) return false
  if (position !== 'final_step') return true
  return !(Number(total) > 0) || Boolean(payOnArrivalRequired)
}
